module.exports = __webpack_public_path__ + "fonts/gilroy-medium.f9f832b.ttf";